import React from "react";
import { NavLink } from "react-router-dom";

import SidebarMenuItems from "./items";
import ItemLabel from "./label";

class item extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isExpanded: false
        };
    }

    get page() {
        return this.props.item;
    }

    toggleExpanded = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ isExpanded: !this.state.isExpanded });
    }

    render() {
        if (this.page.contains && !this.page.contains?.hide) {
            const hasChildren = this.page.contains.items && this.page.contains.items.length > 0;
            
            return (
                <li>
                    <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                        {hasChildren && (
                            <span 
                                onClick={this.toggleExpanded}
                                style={{ 
                                    marginRight: "5px", 
                                    display: "inline-block",
                                    width: "16px",
                                    textAlign: "center",
                                    fontWeight: "bold",
                                    fontSize: "16px"
                                }}
                            >
                                {this.state.isExpanded ? "-" : "+"}
                            </span>
                        )}
                        <NavLink to={this.page.to} exact={this.page.exact} style={{ flex: 1 }}>
                            <ItemLabel icon={this.page.icon} caption={this.page.title} />
                        </NavLink>
                    </div>
                    {this.state.isExpanded && hasChildren && (
                        <ul style={{ 
                            left: "14px", 
                            position: "relative", 
                            marginBottom: "0px",
                            listStyle: "none",
                            paddingLeft: "20px"
                        }}>
                            <SidebarMenuItems items={this.page.contains.items} onPermitted={this.props.onPermitted} />
                        </ul>
                    )}
                </li>
            );
        }
        if (this.page.target) {
            return (
                <li key={this.page.id}>
                    <a href={this.page.to} target={this.page.target} rel="noopener noreferrer">
                        <ItemLabel icon={this.page.icon} source={this.page.source || "line"} caption={this.page.title} />
                    </a>
                </li>
            );
        }
        return (
            <li>
                <NavLink to={this.page.to} exact={this.page.exact}>
                    <ItemLabel icon={this.page.icon} source={this.page.source || "line"} caption={this.page.title} />
                </NavLink>
            </li>
        );
    }
};

export default item;
